import { IPaymentWidgetParams, TWidgetResult } from '../../../../../shared/types/api';
import { IWidgetHandlerContext } from '../../../../../shared/types/widgetContext';
import { launchPaymentWidgetThunk } from '../../../../../shared/thunks/launchPaymentWidget';

export const renderPaymentWidgetHandler =
  (context: IWidgetHandlerContext, isModal: boolean) =>
  async (params: IPaymentWidgetParams): Promise<TWidgetResult> => {
    const { store, getWidgetResultObserver } = context;
    const { price, productType, paymentInitSource, transactionId, packageId } = params;

    store.dispatch(
      launchPaymentWidgetThunk({ price, productType, paymentInitSource, transactionId, packageId, isModal }),
    );

    const result = await getWidgetResultObserver();

    return result;
  };
